import React from 'react';

import Grid, { GridProps } from '../Grid';

// TODO: omit all the props related to `row`
type Props = Omit<GridProps, 'container' | 'item'>;

/**
 * @deprecated Use MUI `Grid` component from `@ha/dsl` instead.
 */
const Col: React.FC<Props> = ({ children, ...rest }) => (
  <Grid {...rest} item container={false}>
    {children}
  </Grid>
);

export { Col };
